import React, { useContext, useMemo } from 'react';
import getOr from '../../../utils/getOr';
import RecordMetaData from '../RecordMetaData/RecordCompareRecordMetaData';
import RecordCompareStateContext from '../../RecordCompareStateContext';
var getAllowSharingValue = getOr('')('data._allow_sharing.value');
function getAllowSharing(recordSecurity) {
  var value = getAllowSharingValue(recordSecurity);
  return value[0] + value.substring(1).toLocaleLowerCase();
}
export default function MetaData(_ref) {
  var record = _ref.record,
    index = _ref.index;
  var _useContext = useContext(RecordCompareStateContext),
    allowSharing = _useContext.allowSharing,
    recordSecurities = _useContext.recordSecurities,
    cardView = _useContext.cardView;
  var recordSecurity = recordSecurities[index];
  var display = useMemo(function () {
    return allowSharing ? getAllowSharing(recordSecurity) : null;
  }, [allowSharing, recordSecurity]);
  return /*#__PURE__*/React.createElement(RecordMetaData, Object.assign({}, record.metaData, {
    allowSharing: display,
    cardView: cardView
  }));
}